// @flow
import React from 'react';
import type { Element } from 'react';

import type { Category } from '@screens/Blog/types';

import { BLOG_CATEGORY } from '@routes';
import { Link } from '@i18n';

import type { Props } from './types';

import {
  StyledList, StyledListItem, StyledListItemContent, StyledCatagoryName
} from './styles';

const CategoryItem = ({
  category,
  isActive
}: {
  category: Category,
  isActive: boolean
}): Element<any> => (
  <StyledListItem>
    <Link
      passHref
      href={BLOG_CATEGORY}
      params={{ slug: category.attributes.slug, id: category.id }}
    >
      <StyledListItemContent>
        <StyledCatagoryName active={isActive}>{category.attributes.title}</StyledCatagoryName>
      </StyledListItemContent>
    </Link>
  </StyledListItem>
);

const CategoryList = ({ categories, activeCategory, t }: Props): Element<any> => (
  <>
    <StyledList>
      <StyledListItem>
        <Link passHref href={BLOG_CATEGORY} params={{ slug: 'blogs', id: 'all' }}>
          <StyledListItemContent>
            <StyledCatagoryName active={activeCategory === 'all'}>
              {t('AllBlogs')}
            </StyledCatagoryName>
          </StyledListItemContent>
        </Link>
      </StyledListItem>
      {categories.map((category: Category) => (
        <CategoryItem
          key={category.id}
          category={category}
          isActive={activeCategory === category.id}
        />
      ))}
    </StyledList>
  </>
);

export default CategoryList;
